import React from 'react';
import { motion } from 'framer-motion';

const Authority = () => {
  return (
    <section className="py-24 border-y border-[#344271] bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-4xl md:text-5xl font-black text-white mb-8 tracking-tight uppercase">
            Built by Claton
          </h2>
          <p className="text-xl md:text-2xl text-[#e2e8f0] leading-relaxed font-medium">
            Work directly with Claton—from initial strategy through final launch. You get direct, end-to-end execution from a builder who understands the local market and knows how to ship.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Authority;